import styles from './SwatchValue.module.scss'

/**
 * Renders a small colored square before a value — used when a colorMode is active
 * so users can correlate the hover data with the SVG fill color without confusing
 * it with availability (green/orange status colors).
 *
 * `cssVar` should be the solid-color variant (e.g. `var(--bim-color-rooms-3-stroke)`).
 */
export function SwatchValue({ cssVar, children }) {
  return (
    <span className={styles.swatchValue}>
      <span 
        className={styles.swatch} 
        style={{ 
          background: `var(${cssVar}-fill)`, 
          borderColor: `var(${cssVar}-stroke)`, 
          }} 
        />
      {children}
    </span>
  )
}